import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';

import routes from './routes-admin';
import store from '../state/store';

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: 'page',
});

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  const publicPages = [
    'admin',
    'login',
    'userLogin',
    'ForgotPassword',
    'verification',
  ];

  const authpage = publicPages.includes(routeTo.name);
  let loggeduser =
    store.state.user &&
    (store.state.user.id_karyawan || store.state.user.id_admin)
      ? store.state.user
      : null;

  const LocalDataVuex =
    localStorage.getItem('amanah') &&
    localStorage.getItem('amanah') !== 'undefined'
      ? JSON.parse(localStorage.getItem('amanah'))
      : false;

  if (LocalDataVuex && LocalDataVuex.access_token && !loggeduser) {
    let data_user = await store.dispatch('getKaryawanInfo');
    if (!data_user) {
      data_user = await store.dispatch('getUserInfo');
    }
    loggeduser = data_user;
  }

  // check expired time jwt token
  if (LocalDataVuex && LocalDataVuex.expired_token) {
    let current_time = new Date();
    if (LocalDataVuex.expired_token) {
      if (new Date(LocalDataVuex.expired_token) < current_time) {
        localStorage.clear();
        // return next('/');
      }
    }
  }

  if (authpage === false && !loggeduser) {
    localStorage.clear();
    return next('/login');
  } else if (loggeduser && authpage) {
    if (loggeduser.id_karyawan) {
      return next('/dashboard');
    } else if (loggeduser.id_admin) {
      return next('/adm/dashboard');
    } else {
      return next();
    }
  } else if (loggeduser && !authpage) {
    if (routeTo.name.toLowerCase().indexOf('dashboard') !== -1) {
      if (
        routeTo.name.toLowerCase().indexOf('admin') !== -1 &&
        loggeduser.id_karyawan
      ) {
        return next('/dashboard');
      } else if (
        routeTo.name.toLowerCase().indexOf('user') !== -1 &&
        !loggeduser.id_karyawan
      ) {
        return next('/adm/dashboard');
      }
    }
  }

  return next();
});

export default router;
